<template>
  <div>
    <CRow>
      <CCol sm="12" md="9" lg="9">
        <label>Fecha:</label>
        <CInput
          :value.sync="$v.form.date.$model"
          :isValid="checkIfValid('date')"
          type="date"
          :horizontal="{ input: 'col-sm-12' }"
          invalidFeedback="Campo requerido"
        />
        <p class="info_text">
          Selecione el día que está realizando el registro del documento
        </p>
      </CCol>
    </CRow>

    <CRow>
      <CCol sm="12" md="9" lg="9">
        <label>Trabajador:</label>
        <v-select
          v-model="form.trabajador"
          :options="trabajadores"
          class="margin-multi"
          :loading="isLoadingPage"
          placeholder="Selecciona un trabajador"
        >
          <template #open-indicator="{ attributes }">
            <CIcon
              v-bind="attributes"
              class="cursor-p"
              name="cil-caret-bottom"
            />
          </template>
        </v-select>
      </CCol>
    </CRow>

    <CRow>
      <CCol sm="12" md="9" lg="9">
        <label>Ubicaciones:</label>
        <div class="d-flex margin-multi align-items-center">
          <MultiSelectC
            v-model="form.ubicaciones"
            :options="ubicaciones"
            :multiple="true"
            label="label"
            :loading="isLoadingPage"
            track-by="label"
            placeholder="Selecciona uno o varias ubicaciones"
            :close-on-select="false"
            :clear-on-select="false"
          >
            <template #no-options>Sin resultados.</template>
          </MultiSelectC>
          <transition name="fade">
            <div
              v-show="form.ubicaciones && form.ubicaciones.length"
              @click="cleanMulti()"
            >
              <CIcon size="lg" class="ml-2 cursor-p" name="cil-trash" />
            </div>
          </transition>
        </div>
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="12" md="9" lg="9">
        <label>Fecha inicial:</label>

        <CInput
          v-model="form.fechaInicial"
          type="date"
          :horizontal="{ input: 'col-sm-12' }"
          invalidFeedback="Campo requerido"
        />
        <p class="info_text">
          Corresponde a la primer semana a partir de la cual se le debe dar el
          bono al trabajador (Debe seleccionar el día de inicio de su semana)
        </p>
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="12" md="9" lg="9">
        <label>Fecha final:</label>
        <CInput
          v-model="form.fechaFinal"
          type="date"
          :horizontal="{ input: 'col-sm-12' }"
          invalidFeedback="Campo requerido"
        />
        <p class="info_text">
          Corresponde a la última semana que se le debe dar el bono al
          trabajador (Debe seleccionar el día en que termina su semana)
        </p>
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="12" md="9" lg="9">
        <CInput
          :value.sync="$v.form.concepto.$model"
          :isValid="checkIfValid('concepto')"
          :label="`Concepto: `"
          placeholder="Concepto..."
          type="text"
        />
      </CCol>
    </CRow>

    <CRow>
      <CCol sm="12" md="9" lg="9">
        <CInput
          :value.sync="$v.form.monto.$model"
          :isValid="checkIfValid('monto')"
          :label="`Monto: `"
          placeholder="Monto..."
          type="number"
        />
      </CCol>
    </CRow>

    <CRow>
      <CCol sm="9">
        <label>Tipo de costo:</label>
        <v-select
          :options="tiposCosto"
          :loading="isLoadingPage"
          class="margin-multi"
          placeholder="Selecciona un tipo de costo"
          v-model="form.tipo_costo"
          :class="checkIfValid('tipo_costo') === false ? 'is-invalid' : ''"
          invalidFeedback="Campo requerido, debe tener al menos 3 caracteres y maximo 50 caracteres"
        >
          <template #footer v-if="checkIfValid('tipo_costo') === false">
            <div class="invalid-feedback">Campo requerido</div>
          </template>
          <template #open-indicator="{ attributes }">
            <CIcon
              v-bind="attributes"
              class="cursor-p"
              name="cil-caret-bottom"
            />
          </template>
          <template #no-options> Sin resultados. </template>
        </v-select>
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="12" md="9" lg="9">
        <CTextarea
          :value.sync="form.comentarios"
          :label="`Comentarios: `"
          placeholder="Comentarios..."
        />
      </CCol>
    </CRow>
    <CRow>
      <CCol sm="12" md="9" lg="9">
        <KlayFileDD
          :fetching="fetching"
          v-model="form.medias"
          :label="`Anexos: `"
          @onFetch="onFetch"
          @onErrorFetch="onErrorFetch"
          :fetchMethod="pushMedia"
          :baseSrc="$store.getters.MediaGet"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>

import Multiselect from "vue-multiselect";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import moment from "moment";

export default {
  mixins: [validationMixin],
  components: {
    vSelect,
    MultiSelectC: Multiselect
  },
  validations: {
    form: {
      date: {
        required,
      },
      concepto: {
        required,
      },
      monto: {
        required,
      },
      tipo_costo: {
        required,
      },
    },
  },
  name: "BonoForm",
  data() {
    return {
      form: {
        date: "",
        trabajador: null,
        ubicaciones: null,
        fechaInicial: null,
        fechaFinal: null,
        concepto: "",
        monto: null,
        tipo_costo: null,
        comentarios: "",
        medias: [],
      },
      tiposCosto: [
        { value: "cosecha", label: "Cosecha" },
        { value: "no_cosecha", label: "No cosecha" },
      ],
    };
  },
  created() {
    this.$emit("handledSubmit", this.handledSubmit);
    this.$emit("setData", this.setData);
  },
  computed: {
    ubicacionRaiz() {
      return this.$store.state.rootLocation;
    },
    isValidDate() {
      return !this.$v.form.date.$invalid;
    },
    isValidConcepto() {
      return !this.$v.form.concepto.$invalid;
    },
    isValidMonto() {
      return !this.$v.form.monto.$invalid;
    },
    isValidTipoCosto() {
      return !this.$v?.form.tipo_costo.$invalid;
    },
  },
  methods: {
    onFetch() {
      this.$emit("onFetch", {});
    },
    onErrorFetch(err) {
      this.$emit("onErrorFetch", err);
    },
    validateBono() {
      this.$v.form.date.$touch();
      this.$v.form.concepto.$touch();
      this.$v.form.monto.$touch();
      this.$v.form.tipo_costo.$touch();
    },
    checkIfValid(fieldName) {
      const field = this.$v.form[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },

    handledSubmit() {
      this.validateBono();

      if (
        this.isValidDate &&
        this.isValidConcepto &&
        this.isValidMonto &&
        this.isValidTipoCosto
      ) {
        if (!this.form.trabajador) {
          return {
            error: "El campo trabajador es obligatorio",
            warningModal: true,
          };
        }

        if (!this.form.ubicaciones && !this.form.ubicaciones.length) {
          return {
            error: "El campo ubicación es obligatorio",
            warningModal: true,
          };
        }

        this.isLoading = true;
        let newDate = moment(this.form.date, "YYYY-MM-DD HH:mm:ss");

        const newUbicaciones =
          this.form.ubicaciones &&
          this.form.ubicaciones.map((ubi) => {
            return ubi.value;
          });
        return {
          schema: "bonos",
          payload: {
            encabezado: {
              fechahora: newDate.format("YYYY-MM-DD HH:mm:ss"),
              trabajador_id: this.form.trabajador && this.form.trabajador.value,
              ubicaciones: newUbicaciones,
              fecha_inicial: this.form.fechaInicial,
              fecha_final: this.form.fechaFinal,
              concepto: this.form.concepto,
              monto: Number(this.form.monto),
              tipo_costo: this.form.tipo_costo ? this.form.tipo_costo.value : "",
              comentarios: this.form.comentarios || "",
              ubicacion_raiz_id: this.ubicacionRaiz
                ? this.ubicacionRaiz.value
                : null,
            },
            anexos: this.form.medias,
          },
        };
      }
      return { skip: true };
    },
    setData(data) {
      Object.assign(this.form, data);
    },
  },
  props: {
    ubicaciones: {
      type: Array,
      required: true,
      default: () => [],
    },
    trabajadores: {
      type: Array,
      required: true,
      default: () => [],
    },
    ubicacionesAll: {
      type: Array,
      required: true,
      default: () => [],
    },
    trabajadoresAll: {
      type: Array,
      required: true,
      default: () => [],
    },
    isLoadingPage: {
      type: Boolean,
      required: true,
      default: false,
    },
    fetching: {
      type: Boolean,
      required: true,
      default: false,
    },
    pushMedia: {
      type: Function,
      required: true,
      default: () => {},
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.margin-multi {
  margin-bottom: 1rem !important;
}
.bg-load-white {
  background-color: white !important;
}
.height-custom {
  height: 25px;
}
.cursor-p {
  cursor: pointer;
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 8px;
    padding-right: 8px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 8px;
    padding-right: 8px;
  }
  .text-sm {
    font-size: 16px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
